// Greenhouse.io (careers) widget does not support SPA transitions
export const requiresFullPageLoad = (href: string): boolean => href.includes('/pages/careers')
